import React from 'react';

import {
  Box,
  Flex,
  ExtendedFlex,
  Heading,
  Body,
  Image,
  VisibilitySensor,
  Theme,
} from '../coreui';

import imageSelectProcess from '../assets/img_panel_opportunity.jpg';


class HowWeSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };
    this.handleSensorChange = this.handleSensorChange.bind(this);
  }

  handleSensorChange(isVisible) {
    if (isVisible) {
      this.setState({
        isVisible: true,
      });
    }
  }

  render() {
    const {
      isVisible,
    } = this.state;

    return (
      <Box
        py={[60, 80, 100, 120, 140]}
      >
        <Flex
          flexDirection={['column', 'column', 'row', 'row', 'row']}
        >
          <Box
            width={[1, 1, 0.5, 0.5, 0.5]}
          >
            <Flex
              flexDirection="column"
              align={['center', 'center', 'flex-end', 'flex-end', 'flex-end']}
            >
              <ExtendedFlex
                flexDirection="column"
                align={['center', 'center', 'flex-start', 'flex-start', 'flex-start']}
                mr={[0, 0, 20, 40, 60]}
                maxWidth={['100%', '100%', 320, 400, 540]}
              >
                <Heading
                  type="H2"
                  display="block"
                  textAlign={['center', 'center', 'left', 'left', 'left']}
                  maxWidth={['75%', 540, '100%', '100%', '100%']}
                  m={0}
                  mb="0.5em"
                  opacity={isVisible ? '1' : '0'}
                  transition={`opacity ${Theme.fadeInDelay}ms 0s linear`}
                >
                  Selecting the right opportunities.
                </Heading>
                <VisibilitySensor
                  callback={this.handleSensorChange}
                />
                <Body
                  type="B1"
                  display="block"
                  textAlign={['center', 'center', 'left', 'left', 'left']}
                  maxWidth={['75%', 540, '100%', '100%', '100%']}
                  opacity={isVisible ? '1' : '0'}
                  transition={`opacity ${Theme.fadeInDelay}ms 0.3s linear`}
                >
                We apply traditional underwriting principles and add deep data insights. Every deal
                is put to the test against our most conservative financial models, and requires
                unanimous approval from our investment committee, whose members came from firms
                such as Rockwood Capital and Bank of Toyko Mitsubishi and who have collectively
                transacted more than $5B in real estate.
                </Body>
                <Body
                  type="B1"
                  display="block"
                  textAlign={['center', 'center', 'left', 'left', 'left']}
                  maxWidth={['75%', 540, '100%', '100%', '100%']}
                  opacity={isVisible ? '1' : '0'}
                  transition="opacity 0.5s 0.3s linear"
                >
                On average, for every 1,000 deals we scrutinize, only one may meet all the criteria
                of our rigorous underwriting process. Once it is determined that each of the
                elements of a transaction are on balance and appear strong enough to accomplish the
                stated investment goals, only then do we offer it to our investors.
                </Body>
              </ExtendedFlex>
            </Flex>
          </Box>
          <Box
            width={[1, 1, 0.5, 0.5, 0.5]}
          >
            <Flex
              flexDirection="column"
              align={['center', 'center', 'flex-start', 'flex-start', 'flex-start']}
              ml={[0, 0, 20, 40, 60]}
            >
              <Image
                src={imageSelectProcess}
                maxWidth="600px"
                IEAspectRatioFix
                opacity={isVisible ? '1' : '0'}
                transition={`opacity ${Theme.fadeInDelay}ms 0.6s linear`}
              />
            </Flex>
          </Box>
        </Flex>
        <VisibilitySensor
          callback={this.handleSensorChange}
        />
      </Box>
    );
  }
}

export default HowWeSelect;
